import { forwardRef, useEffect, useRef } from 'react';
import { useIMask } from 'react-imask';

const DatePickerInput = forwardRef(
  ({ value, onChange, onClick, onBlur, className, ...props }, ref) => {
    const {
      ref: iMaskRef,
      setValue,
    } = useIMask({
      mask: '00/00/0000',
      onComplete: (val) => {
        onChange({ target: { value: val } });
      },
    });

    // Merge the refs: one from forwardRef, one from useIMask
    const inputRef = useRef(null);
    useEffect(() => {
      iMaskRef.current = inputRef.current;
      if (typeof ref === 'function') {
        ref(inputRef.current);
      } else if (ref) {
        ref.current = inputRef.current;
      }
    }, [ref, iMaskRef]);

    // Sync from parent to mask's value
    useEffect(() => {
      if (value !== undefined) {
        setValue(value || '');
        
        // Manual DOM sync to ensure consistency across environments
        if (inputRef.current && inputRef.current.value !== value) {
          inputRef.current.value = value || '';
        }
      }
    }, [value, setValue]);

    const handleBlur = (e) => {
      onChange(e);
      if (onBlur) {
        onBlur(e);
      }
    };

    return (
      <input
        ref={inputRef}
        className={className}
        onClick={onClick}
        onBlur={handleBlur}
        placeholder="dd/mm/aaaa"
        {...props}
      />
    );
  },
);

export default DatePickerInput;